import { createApp } from 'vue';
import { createStore } from 'vuex';
import Toaster from '@meforma/vue-toaster';
import Login from '../login/login';
import App from '../login/app';
import ForgetPassword from '../login/forget-password';
import ChangePassword from '../login/change-password.vue';
import { createRouter, createWebHistory } from 'vue-router';
import mutations from '../stores/login-store/mutations/login-mutations';
import getters from '../stores/login-store/getters/login-getters';
import VueCountryCode from 'vue-country-code';
import {VueTelInput} from 'vue3-tel-input';
import '@vuepic/vue-datepicker/dist/main.css';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import ConfigPlugin from '../plugins/config-plugin.js';
import { installInlineSvgHelpers } from '../utils/register-inline-svg.js';
import { initPosthog } from '../services/posthog-init.js';

initPosthog();

const app = createApp(App);

installInlineSvgHelpers(app);
app.use(VueCountryCode);
app.use(Toaster);
app.use(ConfigPlugin);
app.component('VueTelInput', VueTelInput);


const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/auth/sign_in', name: 'SigninPage', component: Login },
    { path: '/auth/sign_up', name: 'SignupPage', component: Login },
    { path: '/auth/bundle_signup', name: 'BundleSignupPage', component: Login },
    {
      path: '/auth/complete_signup',
      name: 'CompleteSignupPage',
      component: Login,
    },
    { path: '/auth/password/new', name: 'ForgetPasswordPage', component: ForgetPassword },
    { path: '/auth/password/edit', name: 'ChangePasswordPage', component: ChangePassword },
  ],
});
const store = createStore({
  state() {
    return {
      selectedStep: 'login-form',
      trialAmount: 0,
      trialDays: 0,
      requestedOrganization: null,
      currentPlan: '',
      urlParam: '',
      accountType: '',
      superOrg: '',
      freePlan: '',
      fbClickId: '',
      copyCode: '',
      authVerificationSource: '',
      UserEmail: '',
      userForm: {},
      generatedContent: null,
      userHasPhone: false,
    };
  },
  mutations: mutations,
  getters: getters,
});

app.use(store);
app.use(router);
document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.createElement('div');
  document.body.appendChild(appContainer);
  app.mount(appContainer);
});
